import snakeImg from "./project-images/snake-project.png";
import bikeImg from "./project-images/bike-project.png";
import skateImg from "./project-images/skate-project.png";

const allProjects = [
  {
    title: "Ollie",
    stack: ["ReactJS", "NodeJS", "Express", "MongoDB"],
    description:
      "Créez ou rejoignez des événements de skate, et apprenez de nouvelles figures.",
    img: skateImg,
    url: "https://ollie-front.herokuapp.com/",
  },
  {
    title: "Les motos de l'année",
    stack: ["NodeJS", "Express", "MongoDB"],
    description: "Consultez les dernières sorties de 2020.",
    img: bikeImg,
    url: "https://motorcyclespreviews2020.herokuapp.com/index",
  },
  {
    title: "Snake",
    stack: ["HTML Canvas", "CSS", "Javascript"],
    description:
      "Clone de l'incontournable jeux vidéo. Mangez des fruits pour faire grandir le serpent!",
    img: snakeImg,
    url: "https://pauldkn.github.io/snake/",
  },
];

export default allProjects;
